export default __webpack_public_path__ + "static/background-collection-theme-purple.url-91e10f25514ad76bfe846765cc270ed2.svg";